import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, Inject, OnInit, inject } from '@angular/core';
import { CommonComponent } from '@components/abstract/common-component.component';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { ICommunityService } from '@tokens/injection.tokens';
import { ModelService } from '@services/common/model.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { User } from '@models/account/user.model';

@Component({
  selector: 'app-reset-mobile-app-password',
  templateUrl: './reset-mobile-app-password.component.html',
  styleUrls: ['./reset-mobile-app-password.component.scss'],
})
export class ResetMobileAppPasswordComponent
  extends CommonComponent
  implements OnInit
{
  community$ = inject(ICommunityService);
  api = inject(CommonVerbsApiService);
  route = inject(ActivatedRoute);
  router = inject(Router);
  toastr = inject(ToastrService);
  resident: User | null;

  modal = inject(NgbActiveModal);
  builder = inject(UntypedFormBuilder);
  group!: UntypedFormGroup;
  submit = false;
  passwordSaved = false;

  constructor(
    @Inject('ResidentService')
    public residentService: ModelService<User>
  ) {
    super();
    this.resident = residentService.model;
  }

  ngOnInit(): void {
    this.group = this.builder.group(
      {
        password: [null, [Validators.required]],
        passwordConfirmation: [null, [Validators.required]],
      },
      { validator: this.passwordMatchValidator }
    );
  }

  passwordMatchValidator(
    form: AbstractControl
  ): { [key: string]: boolean } | null {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('passwordConfirmation')?.value;

    if (password !== confirmPassword) {
      form.get('password')?.setErrors({ mismatch: true });
      form.get('passwordConfirmation')?.setErrors({ mismatch: true });
      return { mismatch: true };
    } else {
      form.get('password')?.setErrors(null);
      form.get('passwordConfirmation')?.setErrors(null);
    }
    return null;
  }

  validate(name: string): string {
    if (!this.submit) return '';
    const control = this.group.controls[name];
    return control.errors ? 'is-invalid' : 'is-valid';
  }

  ngSubmit(): void {
    this.submit = true;
    if (this.group.valid) {
      const params = {
        ...this.group.getRawValue(),
        userId: this.resident?.id,
      };
      this.unsubscribe.push(
        this.api.post(`users/update-password`, params).subscribe({
          next: value => {
            this.toastr.success(`Password Updated`);
            this.passwordSaved = true;
            localStorage.setItem(
              'password-saved',
              JSON.stringify({ ...params, username: this.resident?.email })
            );
          },
          error: err => this.toastr.error(err?.message || 'An error occurred.'),
        })
      );
    } else {
      this.toastr.error(`Password mismatch`);
    }
  }

  redirect(): void {
    this.router
      .navigate([
        '/communities',
        this.community$.model?.id,
        'residents',
        this.resident?.id,
        'password',
      ])
      .then(() => this.modal.dismiss());
  }
}
